import { action } from 'typesafe-actions'

import { UIActionConsts } from './types'

export const toggleSidebar = () => action(UIActionConsts.TOGGLE_SIDEBAR)
